// CTA Button Dynamic Link Handler
// If on product page, scrolls to product buy box; otherwise uses provided link

(function() {
  function initCTAButtons() {
    const buttons = document.querySelectorAll('.cta__button[data-scroll-to-buy-box="true"]');
    
    if (buttons.length === 0) return;
    
    buttons.forEach(button => {
      // Remove any existing listeners by cloning
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Try multiple selectors to find the product buy box area
        let targetElement = document.querySelector('[id^="MainProduct-"]');
        
        if (!targetElement) {
          targetElement = document.querySelector('[id^="ProductInfo-"]');
        }
        
        if (!targetElement) {
          targetElement = document.querySelector('product-info');
        }
        
        if (!targetElement) {
          targetElement = document.querySelector('.product__info-container');
        }
        
        if (!targetElement) {
          // Fallback: try to find product form
          targetElement = document.querySelector('[id^="product-form-"]');
        }
        
        if (targetElement) {
          // Get the element position
          const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offset = 100; // pixels from top for sticky headers
          
          // Smooth scroll to the element with offset
          window.scrollTo({
            top: elementTop - offset,
            behavior: 'smooth'
          });
        } else {
          console.warn('CTA Button: Could not find product buy box to scroll to');
        }
      });
    });
  }
  
  // Initialize on DOM ready or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCTAButtons);
  } else {
    // DOM already loaded, initialize immediately
    initCTAButtons();
  }
  
  // Also try after a short delay in case product section loads later
  setTimeout(initCTAButtons, 500);
})();

